import { render, staticRenderFns } from "./labelRecord.vue?vue&type=template&id=446cd21f&scoped=true&"
import script from "./labelRecord.vue?vue&type=script&lang=js&"
export * from "./labelRecord.vue?vue&type=script&lang=js&"
import style0 from "./labelRecord.vue?vue&type=style&index=0&id=446cd21f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446cd21f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('446cd21f')) {
      api.createRecord('446cd21f', component.options)
    } else {
      api.reload('446cd21f', component.options)
    }
    module.hot.accept("./labelRecord.vue?vue&type=template&id=446cd21f&scoped=true&", function () {
      api.rerender('446cd21f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/labelRecord.vue"
export default component.exports